var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-space-around":"","column":""}},[_c('v-flex',{staticClass:"centeredOverlay",attrs:{"xs12":""}},[_c('span',[_vm._v(_vm._s(_vm.text ? _vm.text : _vm.$t('noData')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }